const ITEMS = [
  "Intervention dans tout le Val-de-Marne (94)",
  "Déplacement gratuit",
  "Devis gratuit",
  "Réparation — Rénovation — Entretien",
  "Zinguerie & étanchéité",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-midnight/10 bg-bone py-5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((text, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-extrabold uppercase tracking-tight text-midnight/80 text-lg md:text-xl px-8">
                  {text}
                </span>
                <span className="text-signal font-mono text-sm">—</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
